export { default } from "./SpaceSetupSkeleton.jsx";
